import { Component } from '@angular/core';

@Component({
    selector: 'app-matrice-risque',
    templateUrl: './matrice-risque.component.html',
    styleUrls: ['./matrice-risque.component.scss']
})
export class MatriceRisqueComponent {
    // Component is currently stateless, all data is defined in the template
    constructor() { }
} 